import {
  WORKSPACE_FOR_WORKFLOW_QUERY,
  type WorkspaceForWorkflowResult
} from '@/gql/queries/workflow-cards.gql';
import { useWorkspaceFromQuery } from '@/hooks/useWorkspaceFromQuery';

export const useWorkspaceForWorkflow = (workflowId: string) =>
  useWorkspaceFromQuery<WorkspaceForWorkflowResult, { workflowId: string }>({
    query: WORKSPACE_FOR_WORKFLOW_QUERY,
    id: workflowId,
    variables: { workflowId },
    select: data => data?.workflowByRowId?.workspace ?? null
  });
